module.exports = __webpack_public_path__ + "img/11.7bf85dc2.png";